import React, { FC, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { DropdownOption } from '@/src/components/clean/DropdownList/DropdownList';
import Dropdown from '@/src/components/clean/Dropdown/Dropdown';

type ControlledSelectProps = {
  label: string;
  name: string;
  options: DropdownOption[];
  header?: ReactNode;
  footer?: ReactNode;
  id: string;
  className?: string;
  disabled?: boolean;
  showValue?: boolean;
  required?: boolean;
  placeholder?: string;
  infoText?: string;
};

const ControlledSelect: FC<ControlledSelectProps> = ({
  id,
  label,
  name,
  options,
  header,
  footer,
  className,
  disabled,
  showValue = false,
  required = false,
  placeholder,
  infoText,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <Dropdown
            items={options}
            label={label}
            value={field.value || ''}
            error={(errors[name]?.message as string) || ''}
            onClick={(val) => field.onChange(val)}
            header={header}
            footer={footer}
            id={id}
            name={name}
            disabled={disabled}
            className={className}
            showValue={showValue}
            required={required}
            placeholder={placeholder}
            infoText={infoText}
            isMultiselect={false}
          />
        );
      }}
    />
  );
};

export default ControlledSelect;
